import { render, staticRenderFns } from "./CorrectStage.vue?vue&type=template&id=8a212a54&scoped=true"
import script from "./CorrectStage.vue?vue&type=script&lang=js"
export * from "./CorrectStage.vue?vue&type=script&lang=js"
import style0 from "./CorrectStage.vue?vue&type=style&index=0&id=8a212a54&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a212a54",
  null
  
)

export default component.exports